import { api } from "../api";
import { CoOwnerResult, SubmitKennelRequest } from "@/types/portal/Registration";
import { withoutActorIdentity } from "./actorIdentity";

export const searchKennelName = async (searchText: string): Promise<String[]> => {
    const { data } = await api.get<string[]>(`/Kennel/search/${searchText}`);
    return data;
}

export const searchCoOwner = async (membershipID: string): Promise<CoOwnerResult[]> => {
    const { data } = await api.get<CoOwnerResult[]>(`/Person/search/kennel/${membershipID}`)
    return data;
}

export const submitKennelRegistration = async(request: SubmitKennelRequest): Promise<any> => {
    const { data } = await api.post<object>(`/Kennel/register`, withoutActorIdentity(request));
    return data;
}

export const submitChangeKennelOwnerRequest = async(request: Object): Promise<any> => {
    const { data } = await api.post<object>(`/Kennel/owners`, withoutActorIdentity(request));
    return data;
}

export const getKennelById = async(kennelId: String): Promise<any> => {
    const { data } = await api.get<object>(`/Kennel/${kennelId}`);
    return data;
}

export default {
    searchKennelName,
    searchCoOwner,
    submitChangeKennelOwnerRequest,
    getKennelById,
}
